/**
 * @generated SignedSource<<958a507478cd26a1fbc398e90cf4a8c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksTopicWidgetQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly topic: {
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"hooksTopic" | "topicAdsTopic" | "topicMetadataDisplayTopic">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"chinaScienceDiscoveryWidgetQuery" | "discoveryWidgetPostMagazineQueueQuery" | "hundredTopTablesDiscoveryWidgetQuery" | "openQuestionsSeriesDiscoveryWidgetQuery">;
  readonly " $fragmentType": "hooksTopicWidgetQuery";
};
export type hooksTopicWidgetQuery$key = {
  readonly " $data"?: hooksTopicWidgetQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTopicWidgetQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksTopicWidgetQuery"
};

(node as any).hash = "e4f02bb75da4e79a098fc03a215ac214";

export default node;
